import React from 'react';
import { Button, ScreenContainer, ContentFrame, LayoutControls, LayoutContent, LayoutContentCenter, } from '@pinwheel/origami';
import ModalHeader from '../../components/ModalHeader';
import TermsOfService from '../../TermsOfService';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import DocFormImage from '../../assets/graphic-docform.svg';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import useOrgName from '../../hooks/useOrgName';
import DocumentUploadsFileUploadButton from '../../components/DocumentUploads/DocumentUploadsFileUploadButton';
import { useAppSelector } from '../../state';
import { selectStagedDocuments } from '../../state/slices/slice-document-uploads';
import { useOpts } from '../../context';
import { ImageTitleLayout } from '../../components/ImageTitleLayout';
var DocumentUploadsPrimer = function () {
    var getLocalizedString = useGetLocalizedString();
    var fireClientEvent = useOpts().fireClientEvent;
    var orgName = useOrgName();
    var navigate = useLinkNavigate();
    var stagedDocuments = useAppSelector(selectStagedDocuments);
    var subtitle = getLocalizedString('DOCUMENT_UPLOADS_PRIMER', [orgName]);
    return (React.createElement(ScreenContainer, { "data-testid": "DocumentUploads-primer" },
        React.createElement(ModalHeader, { onInfo: function () { return navigate('/info'); } }),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement(LayoutContentCenter, null,
                    React.createElement(ImageTitleLayout, { title: getLocalizedString('UPLOAD_DOCUMENTS'), subtitle: subtitle },
                        React.createElement("img", { src: DocFormImage, alt: "document-form" })))),
            React.createElement(LayoutControls, null,
                React.createElement(TermsOfService, null),
                stagedDocuments.length ? (
                // Only open the file picker on click if no files have been
                // uploaded yet.
                React.createElement(Button, { sx: { margin: '16px 0' }, dataTestId: "button-continue", eventId: "DocumentUploads-continue", onClick: function () {
                        navigate('/document-uploads/list');
                    } }, getLocalizedString('CONTINUE'))) : (React.createElement(DocumentUploadsFileUploadButton, { sx: { margin: '16px 0' }, dataTestId: "button-get-started", eventId: "DocumentUploads-get-started", onFilesAdded: function () {
                        if (fireClientEvent) {
                            fireClientEvent('doc_uploads_begin', {});
                        }
                        navigate('/document-uploads/list');
                    } }, getLocalizedString('GET_STARTED')))))));
};
export default DocumentUploadsPrimer;
